import React, { useContext } from 'react'
import gql from 'graphql-tag'
import { useForm } from 'react-hook-form'

import ButtonSubmit from '../../buttons/ButtonSubmit'
import Form from '../inputs/Form'
import InputText from '../inputs/InputText'
import ModalForgotPasswordSuccess from '../../modals/ModalForgotPasswordSuccess'
import { ModalsContext } from '../../modals/Modals'
import {
  useForgotPasswordFormMutation,
  ForgotPasswordFormMutation,
} from '../../../generated/graphql'

const mutation = gql`
  mutation ForgotPasswordForm($data: String) {
    forgotPassword(data: $data) {
      status
      formErrors
    }
  }
`

const ForgotPasswordForm: React.FC = () => {
  const formCtx = useForm<any>()
  const modalsCtx = useContext(ModalsContext)

  const [mutate, { loading, data }] = useForgotPasswordFormMutation()

  const onSuccess = () => {
    if (!!modalsCtx) {
      modalsCtx.show(
        <ModalForgotPasswordSuccess
          size={800}
          title="Password Reset Instructions Sent"
        />
      )
    }
  }

  return (
    <Form
      autoSubmitEnabled={false}
      dataLossWarningEnabled={false}
      formCtx={formCtx}
      mutate={mutate}
      mutationData={data}
      mutationName="forgotPassword"
      onSuccess={onSuccess}
    >
      <InputText name="email" placeholder="Email" />
      <ButtonSubmit disabled={!!loading}>Reset My Password</ButtonSubmit>
    </Form>
  )
}

export default ForgotPasswordForm
